export const medicationOrderConfig = {
  weekDays: [
    {
      id: 1,
      name: "Monday",
      value: "Mon",
    },
    {
      id: 2,
      name: "Tuesday",
      value: "Tue",
    },
    {
      id: 3,
      name: "Wednesday",
      value: "Wed",
    },
    {
      id: 4,
      name: "Thursday",
      value: "Thu",
    },
    {
      id: 5,
      name: "Friday",
      value: "Fri",
    },
    {
      id: 6,
      name: "Saturday",
      value: "Sat",
    },
    {
      id: 7,
      name: "Sunday",
      value: "Sun",
    },
  ],
  prescribedFrequency: [
    {
      id: 1,
      name: "Daily",
      value: "Daily",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/configs/medication-order-config.ts